module.exports = __webpack_public_path__ + "static/media/vertical04.e386d535.jpeg";